<template>
  <div class="boxType">
    <div class="list">
      <div
        v-for="(item, index) in boxList"
        :key="index"
        style="padding-right: 10px"
        class="itemBox"
      >
        <div class="icon-img">
          <i class="el-icon-close" @click="handleDelete(item, index)"></i>
        </div>
        <span class="select">
          <el-select
            v-model="item.type"
            style="width: 80px"
            :disabled="!boxDisabled"
            @change="handleSelect"
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </span>
        <span style="margin-left: 6px">
          <el-input
            style="width: 120px"
            size="small"
            v-model="item.number"
            type="number"
            :min="1"
            :disabled="!boxDisabled"
            @change="handleChange"
          ></el-input>
        </span>
      </div>
    </div>
    <div class="operate">
      <el-button type="text" size="mini" @click="add">新增</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'boxType',
    props: ['boxList', 'typeList', 'turnType', 'boxDisabled'],
    methods: {
      add() {
        this.$emit('add');
      },
      handleDelete(item, index) {
        if (this.turnType === '3') return;
        this.$emit('deleteItem', item, index);
      },
      handleChange() {
        this.$emit('handleChange');
      },
      handleSelect() {
        console.log('handleSelect');
        this.$emit('handleSelect');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .boxType {
    display: flex;
    flex-direction: row;
    .list {
      display: flex;
      flex-direction: row;
      .itemBox {
        position: relative;
        .icon-img {
          position: absolute;
          top: -10px;
          right: 0px;
        }
      }
    }
    .operate {
      margin-left: 6px;
    }
  }
</style>
